import t from"react";import{MdIcon as r}from"./MdIcon.js";import{mdiCalendarTodayOutline as e}from"@mdi/js";const o=({id:o="calendar",title:i="Calendar",...m})=>t.createElement(r,{id:o,title:i,path:e,...m});export{o as CalendarIcon};
